
define('unknown/defaultMain',[
	'domReady',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		UnknownSetup.initialize();
    });
});